import React from 'react';
import type { Label } from '../../types';

type LabelType =
    | 'badge'
    | 'info'
    | 'neutral'
    | 'negative'
    | 'positive'
    | 'warning';

const classes: { [key in LabelType]: string } = {
    badge: 'mb-8 last-child:mb-0 inline-flex py-2 px-8 border rounded-8 text-12 whitespace-nowrap',
    info: 'bg-[--w-aqua-200] border-[--w-aqua-200] text-[--w-aqua-800]',
    neutral: 'bg-[--w-aqua-50] border-[--w-aqua-50]',
    negative: 'bg-[--w-red-100] border-[--w-red-100] text-[--w-red-800]',
    positive: 'bg-[--w-green-100] border-[--w-green-100] text-[--w-green-800]',
    warning:
        'bg-[--w-yellow-100] border-[--w-yellow-100] text-[--w-yellow-800]',
};

type SecondaryTagProps = {
    className?: string;
    label?: Label;
    labelClass?: string;
    render?: (props: LabelRenderProps) => React.ReactElement | null;
    type?: LabelType;
};

export type LabelRenderProps = {
    className?: string;
    classes: typeof classes;
    label?: Label;
};

export function SecondaryTag(props: SecondaryTagProps) {
    const { className, label, labelClass, render, type = 'neutral' } = props;

    if (!render && !label) {
        return null;
    }

    return (
        <div className={className}>
            {render
                ? render({ className: labelClass, classes, label })
                : renderLabel(type, label!, labelClass)}
        </div>
    );
}

function renderLabel(type: LabelType, label: Label, className: string = '') {
    return (
        <span className={`${className} ${classes.badge} ${classes[type]}`}>
            {label.text}
        </span>
    );
}
